<div class="skill-validation-bg" *ngIf="validationBadge" @opacityInOut></div>
<div class="skill-validation" *ngIf="validationBadge" @scaleInOut>
  <i class="app-ico-mask app-ico-mask__x" (click)="close()"></i>
  <h2>Congratulation</h2>
  <div class="skill-validation__animation">
    <ng-lottie *ngIf="!validationBadge.isSkill" [options]="optionsRocket" (animationCreated)="animationCreated($event)"></ng-lottie>
    <ng-lottie *ngIf="validationBadge.isSkill" [options]="optionsStar" (animationCreated)="animationCreated($event)"></ng-lottie>
  </div>
  <!-- <div class="skill-validation__img" *ngIf="!animationLoaded" [class.is-skill]="validationBadge.isSkill"></div> -->
  <div class="skill-validation__msg">
    <p>Congratulations on passing <b>{{ validationBadge.title }}</b> validation!</p>
    <p>You have received a badge that will be displayed for HM</p>
    <p> Your assessment report is available. Please <b><a class="report"(click)="openReport(validationBadge.reportUrl)">Click here</a></b> to see report</p>
  </div>
  <div class="skill-validation__btns">
    <div class="is-btn" (click)="close()">Okay</div>
  </div>
</div>